// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fE-z","smallCardRow":"gE-z","largeCardRow":"hE-z","productSearchRow":"iE-z","curatedRow":"jE-z"};